import parse from 'html-react-parser'
import { useMemo } from 'react'
import { removeNewLinesFromEnd } from '@omnea-app/frontend/components/shared/form/inputs/rich-text-input/utils'
import { MENTION_REGEX } from '../CommentStringWithMentions'

export const CommentEmptyMessageWithConfiguredText = ({ emptyCommentsMessage }: { emptyCommentsMessage: string }) => {
  return useMemo(() => {
    if (!emptyCommentsMessage) return undefined

    const htmlWithStyledMentions = styleMentions(emptyCommentsMessage)
    const trimmedValue = removeNewLinesFromEnd(htmlWithStyledMentions)

    return parse(trimmedValue, {
      replace: (node) => {
        // strip off any style tags that might make the comment unreadable
        if ('attribs' in node && node.attribs && node.attribs.style) {
          delete node.attribs.style
        }
      },
    })
  }, [emptyCommentsMessage])
}

const styleMentions = (comment: string) => {
  const result = comment.replace(MENTION_REGEX, (_, name) => `<strong>${name}</strong>`)
  return result
}
